import React, { Component } from "react";
import { Form, Label, Button, Dropdown } from "../../../Form";

import withTranslations from "../../../../utils/translations/withTranslations";

class BloodVessels extends Component {
  constructor(...props) {
    super(...props);

    this.state = {
      isValid: true
    };
  }

  next() {
    this.props.saveItem(this.form.formData());
    this.props.next();
  }

  render() {
    const { translate, data = {}, previous } = this.props;
    const { isValid } = this.state;

    return (
      <div className="BloodVessels">
        <Form
          ref={form => (this.form = form)}
          onValidationChange={valid => this.setState({ isValid: valid })}
          className="BloodVessels__Form"
        >
          <h1>{translate("fiche.blood_vessels.title")}</h1>

          <Label text={translate("fiche.blood_vessels.arterial")} />
          <Dropdown
            name="arterial"
            rules={["required"]}
            defaultValue={data.arterial}
            data={[
                { value: '-', 'label': translate("fiche.normal")},
                { value: 'pulsations', 'label': translate("fiche.blood_vessels.pulsations")}
            ]}
          />

          <Label text={translate("fiche.blood_vessels.veneus")} />
          <Dropdown
            name="veneus"
            rules={["required"]}
            defaultValue={data.veneus}
            data={[
                { value: '-', 'label': translate("fiche.normal")},
                { value: 'varices', 'label': translate("fiche.blood_vessels.varices")}
            ]}
          />
          
          <Button
            solid
            className="Form__Button"
            disabled={!isValid}
            onClick={() => this.next()}
          >
            {translate('fiche.next')}
          </Button>
          <Button
            transparant
            className="Form__Button"
            onClick={() => previous()}
          >
            {translate('fiche.previous')}
          </Button>
        </Form>
      </div>
    );
  }
}

export default withTranslations(BloodVessels);
